import { render, staticRenderFns } from "./AdminGpxDetail.vue?vue&type=template&id=4a360166&scoped=true"
import script from "./AdminGpxDetail.vue?vue&type=script&lang=js"
export * from "./AdminGpxDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminGpxDetail.vue?vue&type=style&index=0&id=4a360166&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a360166",
  null
  
)

export default component.exports